module.exports = __webpack_public_path__ + "static/media/Buyer_Puzzle.4b4fdf9e.jpg";